import { useMemo } from 'react'

import { isMobileViewport } from '../styles/breakpoints'

export const MOBILE_CANVAS_MAX_DIMENSION = 1024
export const MOBILE_DRAW_CHUNK_SIZE = 100

export type MobileMapProfile = {
  active: boolean
  skipDummyLayer: boolean
  capCanvasDimension: number | null
  chunkedDraw: boolean
  chunkSize: number
  disableHover: boolean
  disable3d: boolean
}

export function useMobileMapProfile(): MobileMapProfile {
  return useMemo(() => {
    const isMobile = isMobileViewport()
    const deviceMemory = (navigator as Navigator & { deviceMemory?: number })
      .deviceMemory
    const lowMemory = deviceMemory != null && deviceMemory <= 4
    const active = isMobile || lowMemory

    return {
      active,
      skipDummyLayer: active,
      capCanvasDimension: active ? MOBILE_CANVAS_MAX_DIMENSION : null,
      chunkedDraw: active,
      chunkSize: MOBILE_DRAW_CHUNK_SIZE,
      disableHover: active,
      disable3d: active,
    }
  }, [])
}
